import Loader from '@cohort/merchants/components/Loader';

const LoadingState: React.FC = () => (
  <div className="flex h-80 flex-row items-center justify-center rounded-md bg-slate-50">
    <Loader size={60} color="gray" />
  </div>
);

export default LoadingState;
